// extracted by mini-css-extract-plugin
export default {"Chips":"Chips_Chips__JD+mP","Chips__Exiting":"Chips_Chips__Exiting__HU1Uh","Chips__Exited":"Chips_Chips__Exited__wVHi-","Chip__Close":"Chips_Chip__Close__2Jx9q"};